import { Button, Stack } from '@mui/material';
import { useHomePageEditorContext } from '../provider';
import Input from './input';
import { useCreateContext } from './provider';

import Iconify from '@src/components/iconify';
import {
  StyledContainer,
  StyledStackRow,
  styles
} from './styles.css';

function Description() {
  const { setOpenDescription } = useHomePageEditorContext();
  const { state, error, onDispatch } = useCreateContext();

  return (
    <StyledContainer>
      <Button sx={styles.btn_close} onClick={() => setOpenDescription(false)}>
        <Iconify  icon={'mdi:close'} width={25} />
      </Button>
      <StyledStackRow 
        sx={{
          width: "100%",
          flexDirection: {
            xl: "column",
            lg: "column",
            md: "column",
            sm: "column",
            xs: "column",
          },
          gap: {
            xl: "1rem",
            lg: "1rem",
            md: "3rem",
            sm: "1rem",
            xs: "1rem",
          }}} mt={2}>
        <Stack sx={{width: "100%"}}>
          <Input sx={{mt: 1.4}} 
            label={""}
            labelSx={{
              fontSize: 16,
              fontWeight: "700"
            }}
            inputSx={{
              '& .MuiInputBase-root': {
                width: "auto",
                minHeight: '157px',
              },
              "& .MuiOutlinedInput-root": {
                alignItems: "flex-start",
                padding: "12px 14px",           // 👈 Better paragraph feel
              },
              "& .MuiOutlinedInput-input": {
                fontSize: "15px",
                lineHeight: "22px",
                padding: 0,                     // removes default tight padding
              },
            }}
            placeholder='Enter here...'
            error={error.description}
            value={state.description}
            onChange={onDispatch("description")} />
        </Stack>
      </StyledStackRow>
    </StyledContainer>
  );
}

export default Description;